import CustomUIImageStyle from './CustomUIImageStyle'
import CustomUIFontStyle from './CustomUIFontStyle'
import { FileReader, FileWriter } from '@/platform'

class CustomUIGoodItem {
  public Id: number = 0 // 商品ID
  public Name: string = '' // 商品名称
  public Price: number = 0 // 商品价钱
  public PreImge: string[] = [] // 预览图路径列表
  public PreName: string = '' // 预览图名称
  public Pre_x: number = 0 // 预览图x坐标
  public Pre_y: number = 0 // 预览图y坐标
  public Extral: string = '' // 简介
  public FrameColor: string = '' // 边框颜色
  public Width: number = 0 // 单个商品宽
  public Height: number = 0 // 单个商品高
  public X: number = 0 // 单个商品x坐标
  public Y: number = 0 // 单个商品y坐标
  public BuyVarIndex: number = 0 // 购买变量索引
  public PricVarIndex: number = 0 // 价格变量索引
  public BuyedIndex: number = 0 // 已购买字符串索引
  public GoodExIndex: number = 0 // 商品状态二周目索引
  public BuyImage: CustomUIImageStyle = new CustomUIImageStyle() // 购买按钮图片
  public Namef: CustomUIFontStyle = new CustomUIFontStyle() // 商品名文字
  public Pricef: CustomUIFontStyle = new CustomUIFontStyle() // 商品价格文字
  public Extralf: CustomUIFontStyle = new CustomUIFontStyle() // 简介文字

  constructor(
    param?: { id: number; width: number; height: number; x: number; y: number },
  ) {
    if (param === undefined) {
      return
    }
    if ('id' in param) {
      const { id, width, height, x, y } = param

      this.Id = id
      this.Name = ''
      this.Price = 0
      this.PreImge = []
      this.PreName = ''
      this.Pre_x = 0
      this.Pre_y = 0
      this.Extral = ''
      this.FrameColor = '0,0,0'
      this.Width = width
      this.Height = height
      this.X = x
      this.Y = y
      this.BuyVarIndex = 0
      this.PricVarIndex = 0
      this.BuyedIndex = 0
      this.GoodExIndex = 0
      this.BuyImage = new CustomUIImageStyle()
      this.Namef = new CustomUIFontStyle()
      this.Pricef = new CustomUIFontStyle()
      this.Extralf = new CustomUIFontStyle()
    }
  }

  readBin(reader: FileReader): void {
    this.Id = reader.readInt()
    this.Name = reader.readString()
    this.Price = reader.readInt()
    const preLen = reader.readInt()
    this.PreImge = []
    for (let i = 0; i < preLen; i++) {
      this.PreImge.push(reader.readString())
    }
    this.PreName = reader.readString()
    this.Pre_x = reader.readInt()
    this.Pre_y = reader.readInt()
    this.Extral = reader.readString()
    this.FrameColor = reader.readString()
    this.Width = reader.readInt()
    this.Height = reader.readInt()
    this.X = reader.readInt()
    this.Y = reader.readInt()
    this.BuyVarIndex = reader.readInt()
    this.PricVarIndex = reader.readInt()
    this.BuyedIndex = reader.readInt()
    this.GoodExIndex = reader.readInt()
    this.BuyImage = new CustomUIImageStyle(reader)
    this.Namef = new CustomUIFontStyle(reader)
    this.Pricef = new CustomUIFontStyle(reader)
    this.Extralf = new CustomUIFontStyle(reader)
  }

  writeBin(writer: FileWriter): void {
    writer.writeInt(this.Id)
    writer.writeString(this.Name)
    writer.writeInt(this.Price)
    writer.writeInt(this.PreImge.length)
    for (let i = 0; i < this.PreImge.length; i++) {
      writer.writeString(this.PreImge[i]!)
    }
    writer.writeString(this.PreName)
    writer.writeInt(this.Pre_x)
    writer.writeInt(this.Pre_y)
    writer.writeString(this.Extral)
    writer.writeString(this.FrameColor)
    writer.writeInt(this.Width)
    writer.writeInt(this.Height)
    writer.writeInt(this.X)
    writer.writeInt(this.Y)
    writer.writeInt(this.BuyVarIndex)
    writer.writeInt(this.PricVarIndex)
    writer.writeInt(this.BuyedIndex)
    writer.writeInt(this.GoodExIndex)
    this.BuyImage.writeBin(writer)
    writer.writeInt(this.Namef.FontSize)
    writer.writeString(this.Namef.FontName)
    writer.writeString(this.Namef.FontCor)
    writer.writeInt(this.Namef.X)
    writer.writeInt(this.Namef.Y)
    writer.writeInt(this.Pricef.FontSize)
    writer.writeString(this.Pricef.FontName)
    writer.writeString(this.Pricef.FontCor)
    writer.writeInt(this.Pricef.X)
    writer.writeInt(this.Pricef.Y)
    writer.writeInt(this.Extralf.FontSize)
    writer.writeString(this.Extralf.FontName)
    writer.writeString(this.Extralf.FontCor)
    writer.writeInt(this.Extralf.X)
    writer.writeInt(this.Extralf.Y)
  }
}

export default CustomUIGoodItem
